'use client'

import React from 'react'
import clsx from 'classnames'
import { motion } from 'framer-motion'
import { Text } from '@/shared/ui'

import { useAppearance } from '@/shared/utils'
import { variantsHeadline } from '@/shared/constants/variants'
import style from './quote.module.scss'

interface QuoteProps extends React.HTMLProps<HTMLDivElement> {
  text?: string
  name?: string
  position?: string
}

export const Quote = (props: QuoteProps) => {
  const { className, text, name, position } = props

  const { ref: innerRef, animate } = useAppearance()

  return (
    <motion.div
      ref={innerRef}
      animate={animate}
      variants={variantsHeadline}
      className={clsx(style.container, className)}
    >
      <Text className={style.symbol} type="h1" color="main-blue">
        “ ”
      </Text>
      <Text className={style.quote} type="t2" color="dark" tagName="div" __html={text} />
      <Text className={style.name} type="t2" color="main-blue" __html={name} />
      <Text className={style.position} type="t3" color="primary-bg-070" __html={position} />
    </motion.div>
  )
}
